export const REQUIRED_MSG = 'This field is required';
export const SUPPORT_EMAIL = 'info@keyown.com';
